export enum Theme {
  Dark = 'dark',
  Light = 'light',
}
